<template>
  <main class="">
    <project-tree v-if="project"></project-tree>
    <p class="btn-hint name-hint btn-hint_bottom btn-hint-navigator">

    </p>
  </main>
</template>

<script>
  import {projectPageMixin} from "../../mixins/projects/projectPageMixin";

  export default {
    name: 'projectItemPage',
    mixins: [projectPageMixin],
    watch: {
      routeItem(val) {
        this.setIsProjectItem(val);
        this.setRouteName(this.project.name);
      }
    },
    beforeRouteEnter(to, from, next) {
      next(async vm => {
        const params = vm.$route.params;
        const ID = params.id;
        const ITEM = params.item;

        vm.setIsProjectItem(ITEM);

        vm.showLoader();
        // await vm.getUsers();
        // await vm.getInvitedUsers();

        await vm.getProject(ID);

        vm.setFullSidebar(false);
        vm.setLinkName('projects');
        vm.setRouteName(vm.project.name);
        vm.getOwnedRoles();
        vm.hideLoader();
      })
    }
  }
</script>

<style lang="scss" scoped>

  .project-page {
    padding-bottom: 30px;
    display: flex;
  }

  .project-body {
    width: 100%;
    padding-left: 70px;
    position: relative;
  }

  .project-body_open {
    padding-left: 300px;

    @media screen and (max-width: 1500px) {
      padding-left: 250px;
    }

    @media screen and (max-width: 1370px) {
      padding-left: 200px;
    }
  }
</style>
